import { useCallback } from "react";
import { useAppContext } from "../AppProviders";
import { API_URL } from "./helpers";
import {
  BooleanSearchRoundResponse,
  BooleanSearchSavePayload,
} from "./BooleanSearch";
import { WebSearchRunResponse } from "./WebSearchAPI";

export function useBooleanSearchApi() {
  const { requestApi } = useAppContext();

  const fetchRounds = useCallback(
    async (reportUuid: string): Promise<BooleanSearchRoundResponse[]> => {
      const response = await requestApi.get(
        `${API_URL}/360/reports/${reportUuid}/boolean-search`
      );
      return response.data;
    },
    [requestApi]
  );

  const saveRounds = useCallback(
    async (
      reportUuid: string,
      payload: BooleanSearchSavePayload
    ): Promise<BooleanSearchRoundResponse[]> => {
      const response = await requestApi.put(
        `${API_URL}/360/reports/${reportUuid}/boolean-search`,
        payload
      );
      return response.data;
    },
    [requestApi]
  );

  const submitRounds = useCallback(
    async (
      reportUuid: string,
      payload: BooleanSearchSavePayload
    ): Promise<WebSearchRunResponse> => {
      const response = await requestApi.post(
        `${API_URL}/360/reports/${reportUuid}/boolean-search/start`,
        payload
      );
      return response.data;
    },
    [requestApi]
  );

  return {
    fetchRounds,
    saveRounds,
    submitRounds,
  };
}
